// extracted by mini-css-extract-plugin
export var clickThrough = "_yn-2";
export var fallback = "_yn-5";
export var frame = "_yn-3";
export var frameCell = "_yn-1";
export var overlay = "_yn-4";
export var wrapper = "_yn-0";